import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { PHP } from '../../../utils/axiosConfig';
import { Alert } from 'react-bootstrap';
import validateEmail from '../../../utils/validateEmail';

function CreateUser({ setShowModal }) {
	const php = PHP();

	const [form, setFormData] = useState({
		firstName: '',
		lastName: '',
		email: '',
	});
	const [errors, setErrors] = useState({});
	const [message, setMessage] = useState(null);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFormData({
			...form,
			[name]: value,
		});
	};

	const validateForm = () => {
		let errors = {};
		if (!form.firstName) {
			errors.firstName = 'Please provide First Name.';
		}
		if (!form.lastName) {
			errors.lastName = 'Please provide Last Name.';
		}
		if (!form.email) {
			errors.email = 'Please provide Email.';
		} else {
			if (!validateEmail(form.email)) {
				errors.email = 'Please provide a valid Email.';
			}
		}

		setErrors(errors);
		return Object.keys(errors).length === 0;
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		if (validateForm()) {
			const formData = new FormData();
			formData.append('route', 'create_user');
			formData.append('firstname', form.firstName);
			formData.append('lastname', form.lastName);
			formData.append('email', form.email);

			php
				.post('user.php', formData)
				.then((res) => {
					if (res.status === 200) {
						setMessage({ text: res.data.message, type: 'success' });
					}
				})
				.catch((err) => {
					if (err.response.status === 400) {
						//This should be email already in use error
						setErrors({ ...errors, email: 'Email address in use.' });
					} else {
						setMessage({ text: 'Failed to Create User', type: 'danger' });
					}
				});
		}
	};

	return (
		<div id="create-user-form">
			<Form onSubmit={handleSubmit}>
				<Form.Group controlId="firstName">
					<Form.Label>First Name</Form.Label>
					<Form.Control
						type="text"
						name="firstName"
						value={form.firstName}
						onChange={handleChange}
						isInvalid={errors.firstName}
					/>
					{errors.firstName && <Form.Text>{errors.firstName}</Form.Text>}
				</Form.Group>

				<Form.Group controlId="lastName">
					<Form.Label>Last Name</Form.Label>
					<Form.Control
						type="text"
						name="lastName"
						value={form.lastName}
						onChange={handleChange}
						isInvalid={errors.lastName}
					/>
					{errors.lastName && <Form.Text>{errors.lastName}</Form.Text>}
				</Form.Group>

				<Form.Group controlId="email">
					<Form.Label>Email</Form.Label>
					<Form.Control
						type="email"
						name="email"
						value={form.email}
						onChange={handleChange}
						isInvalid={errors.email}
					/>
					{errors.email && <Form.Text>{errors.email}</Form.Text>}
				</Form.Group>

				{message && (
					<div
						className={
							message.type === 'danger'
								? 'text-center dangerColor'
								: 'text-center successColor'
						}
					>
						{message.text}
					</div>
				)}

				<div className="d-grid mt-4">
					<Button variant="primary" type="submit">
						Register
					</Button>
				</div>
			</Form>
		</div>
	);
}

export default CreateUser;
